<div ngbDropdown [autoClose]="autoClose" #dropDown="ngbDropdown">
    <div
        class="form-control"
        ngbDropdownAnchor
        [attr.readonly]="disabled ? true : null"
        (click)="toggle()">
        <span class="text-ellipsis">{{selectedValue || placeholder}}</span>
    </div>
    <div class="dropdown-menu" ngbDropdownMenu>
        <ng-container *ngTemplateOutlet="dropDownMenu; context: { $implicit: dropDown }"></ng-container>
    </div>
</div>
